import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { SelectOption } from "../../../common/types"

export class Service {

    static get() {
        const res = AppContext.getApiClient().get("/taxes")
        if (res.error) {
            throw new Error(res.error.message)
        } 
        return res
    }

    static delete(id: string) {
        return AppContext.getApiClient().delete(`/taxes/${id}`)
    }

    static async getAsSelectOptions(): Promise<SelectOption<string>[]> {
        const res = await AppContext.getApiClient().get("/taxes")

        if (res.data && Array.isArray(res.data)) {
            return res.data.map(tax => ({
                value: tax.id,
                label: `${tax.attributes.name} (${tax.attributes.totalRate}%)`,
            }))
        }

        return []
    }
}


// WEBPACK FOOTER //
// ./src/state/tax/service/service.ts